<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event.target.value)"
    persistent
    :style="{ overflow: 'hidden' }"
    transition="dialog-transition"
  >
    <v-card color="primary" :style="{ height: '80vh', overflow: 'hidden' }">
      <v-toolbar color="primary" flat>
        <v-toolbar-side-icon icon @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-toolbar-side-icon>
      </v-toolbar>
      <div :style="{ height: '80%' }" v-if="homeScreen">
        <v-card color="primary" :style="{ textAlign: 'center' }" flat>
          <div :style="{ textAlign: 'center' }">
            <h1>What would you like to do?</h1>
          </div>
          <v-layout column>
            <v-btn
              class="mx-auto"
              :style="{ width: '40%', height: '15vh' }"
              @click="
                homeScreen = false;
                newVideo = true;
                imgSrc = '';
              "
              >Create a New Video</v-btn
            >

            <v-btn
              class="mx-auto"
              :style="{ width: '40%', height: '15vh' }"
              @click="
                homeScreen = false;
                videoList = true;
                getRecording();
              "
              >View Current Video</v-btn
            >
            <v-btn
              class="mx-auto"
              :style="{ width: '40%', height: '15vh' }"
              @click="generatePublicLink()"
              >Generate Public Link</v-btn
            >
            <v-textarea
              @click="copyToClipboard()"
              ref="publicURL"
              color="secondary"
              label="Public URL"
              v-model="publicURL"
              class="mx-auto mt-2"
              :style="{ width: '40%', height: '15vh' }"
              readonly
              box
            />
          </v-layout>
        </v-card>
      </div>

      <v-layout
        justify-center
        column
        :style="{ height: '80%' }"
        v-if="newVideo"
      >
        <v-flex xs1>
          <v-layout row wrap justify-center>
            <v-btn @click="getPreview" :disabled="isRecording"
              >Align Camera</v-btn
            >
            <v-btn @click="startRecording" :disabled="isRecording"
              >Start Recording</v-btn
            >
            <v-btn @click="stopRecording" :disabled="!isRecording"
              >Finish Recording</v-btn
            >
          </v-layout>
        </v-flex>
        <v-flex xs10>
          <div
            :style="{
              width: '50vw',
              height: '100%',
              display: 'flex',
              alignItems: 'center'
            }"
            class="mx-auto"
          >
            <div v-if="isRecording" class="circle record-blink mx-auto" />
            <v-img
              v-if="imgSrc"
              :src="`data:image/jpg;base64, ${imgSrc}`"
              :style="{ width: '50vw', height: '100%' }"
            ></v-img>
          </div>
        </v-flex>

        <v-flex xs1 class="mx-auto mt-2">
          <v-btn
            @click="
              homeScreen = true;
              newVideo = false;
              isRecording = false;
            "
            >Go Back</v-btn
          >
        </v-flex>
      </v-layout>

      <v-layout
        justify-center
        column
        :style="{ height: '80%' }"
        v-if="videoList"
      >
        <div v-if="videoSrc" :style="{ width: '65vw' }" class="mx-auto">
          <video
            controls
            style="width: 100%;"
            :src="videoSrc"
            type="video/mp4"
          />
        </div>
        <v-layout
          v-else
          :style="{
            width: '65vw',
            textAlign: 'center',
            backgroundColor: 'rgba(191, 191, 191, .6)',
            height: '80%'
          }"
          class="mx-auto"
          column
        >
          <v-flex xs3> </v-flex>
          <v-flex xs2>
            <v-icon :style="{ fontSize: '60px' }">sync_problem</v-icon>
          </v-flex>
          <v-flex xs2>
            <h1>
              Video is still processing...
            </h1>
            <h2>Please go back and try again...</h2>
          </v-flex>
        </v-layout>
        <v-flex xs1 class="mx-auto mt-2">
          <v-btn
            @click="
              homeScreen = true;
              videoList = false;
            "
            >Go Back</v-btn
          >
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import Axios from "axios";
import CONSTANTS from "@/constants";
import { mapActions } from "vuex";

export default {
  name: "videoDialog",
  props: ["value", "rma"],

  data() {
    return {
      homeScreen: true,
      newVideo: false,
      videoList: false,
      videoSrc: "",
      publicURL: "",
      imgSrc: "",
      isRecording: false,
      token:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJiaW5kbGUiOnt9LCJleHAiOjE3NDc2MDIzMTcuMCwiaWF0IjoxNTg5OTIyMzE3LjB9.K_TE9MTKVZY97NTEGiRwHqPHHsRQsvfw_cjgCZ0wbgY"
    };
  },

  watch: {
    value() {
      this.homeScreen = true;
      this.newVideo = false;
      this.videoList = false;
      this.isRecording = false;
      this.videoSrc = "";
      this.publicURL = "";
      this.imgSrc = "";
    }
  },

  methods: {
    ...mapActions({
      update: "rma/update"
    }),

    async getPreview() {
      this.imgSrc = "";
      this.isRecording = false;
      try {
        const { data } = await Axios({
          method: "GET",
          url: `${CONSTANTS.VIDEO_URL}/image/preview`,
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        });

        this.imgSrc = data.data;
      } catch (error) {
        this.$store.dispatch("app/setSnackbar", {
          text: error.message,
          color: "red"
        });
      }
    },

    async startRecording() {
      this.imgSrc = null;
      try {
        await Axios({
          method: "POST",
          url: `${CONSTANTS.VIDEO_URL}/video/start`,
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        });

        this.isRecording = true;
      } catch (error) {
        this.$store.dispatch("app/setSnackbar", {
          text: error.message,
          color: "red"
        });
      }
    },

    async stopRecording() {
      this.isRecording = false;
      try {
        await Axios({
          method: "POST",
          url: `${CONSTANTS.VIDEO_URL}/video/stop`,
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          data: {
            rmaid: this.rma.id
          }
        });

        await this.update({ id: this.rma.id, updates: { returnVideo: true } });

        this.$store.dispatch("app/setSnackbar", {
          text: "Recording saved successfully!",
          color: "green"
        });
      } catch (error) {
        this.$store.dispatch("app/setSnackbar", {
          text: error.message,
          color: "red"
        });
      }
    },

    async getRecording() {
      this.videoSrc = null;
      try {
        const { data } = await Axios({
          method: "GET",
          url: `${CONSTANTS.VIDEO_URL}/video/link?rmaid=${this.rma.id}`,
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        });
        if (data.length > 1) {
          this.$store.dispatch("app/setSnackbar", {
            text: data[0].Description,
            color: "red"
          });
        } else this.videoSrc = data.vid;
      } catch (error) {
        this.$store.dispatch("app/setSnackbar", {
          text: error.message,
          color: "red"
        });
      }
    },

    async generatePublicLink() {
      this.publicURL = null;
      try {
        const { data } = await Axios({
          method: "GET",
          url: `${CONSTANTS.VIDEO_URL}/video/public_link?rmaid=${this.rma.id}`,
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        });

        this.publicURL = data.vid;
      } catch (error) {
        this.$store.dispatch("app/setSnackbar", {
          text: error.message,
          color: "red"
        });
      }
    },

    copyToClipboard() {
      if (this.publicURL) {
        let textToCopy = this.$refs.publicURL.$el.querySelector("textarea");
        textToCopy.select();
        document.execCommand("copy");
        this.$store.dispatch("app/setSnackbar", {
          text: "URL Copied to Clipboard",
          color: "green"
        });
      }
    }
  }
};
</script>

<style>
.circle {
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: radial-gradient(circle, red, #000);
  background-color: red;
}

.record-blink {
  animation: blinker 1.5s cubic-bezier(0.5, 0, 1, 1) infinite alternate;
}

@keyframes blinker {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
